import { render, staticRenderFns } from "./TopicForm.vue?vue&type=template&id=0d1ead89&scoped=true&"
import script from "./TopicForm.vue?vue&type=script&lang=js&"
export * from "./TopicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1ead89",
  null
  
)

export default component.exports